export const resources = {
    en: {
      translation: {
        "optional" : "optional",
        "reset search": "reset search",

        // Data loss notice
        "notice_title": "An important notice",
        "notice_body": "Following a recent regional infrastructure disruption affecting our database hosting, our salary data was lost. We're rebuilding from the ground up and will be back soon. Thank you for your patience.",
        "notice_cta": "Add your salary →",
        "notice_dismiss": "Dismiss",

        // Navbar
        "navbar_search": "Search...",
        "navbar_home": "Home",
        "navbar_explore": "Explore",
        "navbar_companies": "Companies",
        "navbar_about": "About",
        "navbar_for_employers": "For Employers",
        "navbar_signin": "Sign in",
        "navbar_profile": "Profile",
        "navbar_add_salary": "Add Salary",
        "navbar_logout": "Log Out",
        
        // Banner
        "banner_empowering_your_pay": "Know Your Worth",
        "banner_one_click_at_a_time": "Empower Your Pay",
        "banner_contribute": "Contribute your work history →",

        // Main page
        "main_salaries": "Salaries",
        "main_companies": "Companies",
        "main_featured_companies": "Featured Companies",
        "main_featured_roles": "Featured Roles",
        "recent_submissions": "Recent Salary Submissions",
        "main_view_all": "View All →",
        "card_exp": "Years of Experience",
        "main_role": "Role",
        "main_privacy": "Privacy Protection",
        "main_privacy_details": "We prioritize maintaining the confidentiality and security of your information.",
        "main_precision": "Precision Verification",
        "main_precision_details": "Verified data for precise insights, guiding compensation plans for startups and Fortune 500 tech companies.",
        "main_no_cost": "No Cost",
        "main_no_cost_details": "Enjoy our services completely free of charge, without any financial costs.",
        "main_no_salaries": "No salaries match your current criteria",
        "main_no_salaries_details": "Help us enhance and promote transparency in compensation by",
        "main_no_salaries_link": "submitting your salary",
        "main_no_salaries_details_part_2": "or sharing this site with others.",

        // Calculator
        "calc_title": "Salary Calculator",
        "calc_years_of_exp": "Years of Experience",
        "calc_role": "Role",
        "calc_education_level": "Education Level",
        "calc_location": "Location",
        "calc_calculate": "Calculate",
        "calc_estimated": "Estimated Salary Range",
        "calc_error_msg": "The calculator is not working at the moment. It will be available once there is enough data.",


        // FAQ
        "FAQs": "FAQs",
        "faq_services_free_q": "Are your services free to users?",
        "faq_services_free_a": "Absolutely, our services are free to all users.",
        "faq_anonymous_q": "Is it anonymous?",
        "faq_anonymous_a": "Yes, our website values your privacy, and we ensure that everything is done anonymously.",
        "faq_about_q": "What is your website about?",
        "faq_about_a": "Our website is a salary database where users can look up salaries for specific positions and companies.",
        "faq_contribute_q": "How can I contribute to the salary database?",
        "faq_contribute_a": "Click here to add your salary.",
        "faq_provide_q": "Do you provide salary data for all industries?",
        "faq_provide_a": "We aim to cover a wide range of industries, but our coverage may vary.",
        "faq_request_q": "Can I request salary data for a specific job title?",
        "faq_request_a": "Click here to navigate to the explore page.",
        "faq_updated_q": "Is the salary data updated regularly?",
        "faq_updated_a": "Yes, we strive to keep our salary data updated regularly to provide accurate information.",
        "faq_account_q": "Do I need an account to add my salary?",
        "faq_account_a": "No, but an account can help you keep track of your contribution.",
        "faq_premium_q": "Do you offer any premium services?",
        "faq_premium_a": "Currently, we only offer our standard services for free to all users.",

        // Footer
        "footer_contact": "Contact",
        "footer_tos": "Terms of Service",
        "footer_home": "Home",
        "copyright": "© 2025 Ratib LLC. All Rights Reserved.",

        // Login page
        "login_signin": "Sign in",
        "login_email": "Email",
        "login_password": "Password",
        "login_forgot_password": "Forgot password?",
        "login_login": "Login",
        "login_not_a_member": "Not a member? Sign up now",
        "login_alert_no_account": "Could not find an account matching the credentials provided",

        //signup page
        "signup_header": "Sign Up",
        "signup_email": "Email",
        "signup_email_invalid": "Invalid Email",
        "signup_password" : "Password",
        "signup_password_alert": "Password must be at least 8+ characters and include letters and numbers.",
        "signup_password_reentry" : "Re-Enter Password",
        "signup_password_reentry_alert": "The re-entry doesn't match.",
        "signup_phone":"+9665xxxxxxxx",
        "signup_phone_alert": "Invalid Phone Number.",
        "signup_edu": "Education Level",
        "signup_edu_options": ["Secondary","Diploma","Bachelor","Masters","PHD","Associate", "MBA"],
        "signup_button": "Sign Up",
        "signp_captcha_error":"Submit the captcha to proceed.",
        "signup_email_inuse": "Email or phone number already in use",
        "signup_general_error": "An error occurred, please try again later.",
        "signup_attempts_error": "You have exceeded the maximum number of attempts. Please try again later.",

        //add salary page
        "addsalary_header":"Add your work history",
        "addsalary_company": "Company Name",
        "addsalary_role":"Role",
        "addsalary_exp":"Years of Experience",
        "addsalary_edu":"Education Level",
        "addsalary_edu_options":["Secondary","Diploma","Bachelor","Masters","PHD","Associate", "MBA"],
        "addsalary_num_error":"Enter a number.",
        "addsalary_country":"Country",
        "addsalary_region":"State/Region",
        "addsalary_city":"City",
        "addsalary_salary":"Monthly Salary",
        "addsalary_submit":"Submit Salary",
        "addsalary_success": "Your entry has been added successfully! Redirecting to home in 5 seconds...",
        "addsalary_fail":"Something went wrong, please try again later.",
        "addsalary_captcha":"Please complete the captcha before submitting.",
        "addsalary_currency": "Currency",


        //explore page
        "discover_title": "Discover Salaries",
        "search_role": "Search Roles...",
        "search_companies": "Search Companies...",
        "search_locations": "Search Locations...",

        //discover companies page
        "discover_companies": "Discover Companies",
        "companies_subtitle": "search by company and discover their salaries and roles",
        "search_a_company": "Search Companies...",
        "popular_companies": "Popular Companies",
        "404_company": "could not find this company",

        //company page
        "company_median_title": "{companyDisplay}'s Median Salaries",
        "company_listed_title": "{companyDisplay}'s Recently Listed Salaries",
        "company_no_salaries" : "We have no salary enteries for this company",
        "company_median_sub": "{companyDisplay}'s salary ranges from SAR {minSalary.median} per month for a {capitalizeEveryWord(minSalary.role)} at the low-end to SAR {maxSalary.median} for a {capitalizeEveryWord(maxSalary.role)} at the high-end.",
        "related_companies": "Related Companies",
        "discover_companies_related": "Discover Companies →",

        //about us page
        "mission_content": "Our mission is to empower individuals with the knowledge and insights needed to make informed decisions about their careers.",
        "vision_title": "Our Vision",
        "vision_desc" : "Provide clarity and transparency in the job market, empowering individuals to make informed decisions and gain leverage in their career paths.",
        "mission_title": "Our Mission",
        "mission_desc": "Push boundaries, fostering innovation and embracing new ideas to shape the future of the job market.",
        "innovation_title": "Innovation",
        "innovation_desc": "Constantly push boundaries, fostering creativity and embracing new ideas to shape the future.",
        "customer_title": "Customer-Centric",
        "customer_desc": "Customers are at the core of everything we do. We prioritize their needs and satisfaction.",
        "passion_title": "Passion",
        "passion_desc": "We are passionate about our work and strive for excellence in everything we do.",
        "quality_title": "Quality",
        "quality_desc": "We are committed to delivering the highest quality products and services to our customers.",

        //employers page
        "offering_work": "Work with us!",
        "offering_work_desc": "Use our in-depth salary data to learn about competitors' compensation practices. Fill gaps with an unparalleled level of specificity that salary surveyors cannot provide.",
        "touch_button": "Get In Touch",
        "offering_hire": "Hire Senior Talent",
        "offering_hire_desc": "Put a megaphone to your company’s brand and highlight your employer’s value proposition. Promote jobs on our job board, and strategically target talent for your open roles.",
        "offering_150000": "150,000+",
        "offering_150000_desc": "Create attractive benefit packages that attract and retain top talent. Use our data-driven approach to tailor packages that meet your employees' needs.",
        "offering_7000": "7000+",
        "offering_7000_desc": "Enhance your employer brand with our platform. Showcase your company’s culture, values, and opportunities to attract the right talent.",
        "offering_contact": "Contact Us",
        "offering_contact_desc": "Email: contact@ratib.io \n Phone: +966 545 402 2312",

        //404 page
        "404page_msg":"There is nothing for you to see here pardner!"

      }
    },
    ar: {
      translation: {
        "optional" : "اختياري",
        "reset search": "إعادة البحث",

        // Data loss notice
        "notice_title": "إشعار مهم",
        "notice_body": "نتيجةً لاضطراب إقليمي حدث مؤخرًا وأثّر على البنية التحتية التي تستضيف قواعد بياناتنا، فقدنا بيانات الرواتب الخاصة بالموقع. نعمل حاليًا على إعادة بناء البيانات من الصفر، وسنعود قريبًا. شكرًا لكم على صبركم وتفهمكم.",
        "notice_cta": "أضف راتبك ←",
        "notice_dismiss": "إغلاق",

        //navbar
        "navbar_search": "بحث...",
        "navbar_home": "الرئيسية",
        "navbar_explore": "استكشف",
        "navbar_companies": "الشركات",
        "navbar_about": "نبذة عنا",
        "navbar_for_employers": "لأصحاب العمل",
        "navbar_signin": "تسجيل الدخول",
        "navbar_profile": "ملف المستخدم",
        "navbar_add_salary": "إضافة راتبك",
        "navbar_logout": "تسجيل خروج",
        // Banner
        "banner_empowering_your_pay": "أعرف قيمتك في السوق",
        "banner_one_click_at_a_time": "اكتشف اللي تستاهله",
        "banner_contribute": "ساهم بإضافة راتبك اليوم ←",

        // Main page
        "main_salaries": "راتب",
        "main_companies": "شركة",
        "main_featured_companies": "الشركات المسجلة",
        "main_featured_roles": "مناصب مميزة",
        "recent_submissions": "أحدث الرواتب المقدمة",
        "main_view_all": "عرض الكل ←",
        "card_exp": "سنوات خبرة",
        "main_role": "المنصب",
        "main_privacy": "حماية الخصوصية",
        "main_privacy_details": " أولوياتنا الحفاظ على سرية وأمن معلوماتك.",
        "main_precision": "تحقق من الدقة",
        "main_precision_details": "بيانات مؤكدة لرؤى دقيقة، توجه خطط الرواتب للشركات الناشئة وشركات فورتشن 500 التقنية.",
        "main_no_cost": "مجانا",
        "main_no_cost_details": "تمتع بخدماتنا مجاناً تمامًا، بدون أي تكاليف مالية.",
        "main_no_salaries": "لا توجد رواتب مطابقة لخياراتك الحالية",
        "main_no_salaries_details": "ساعدنا في تعزيز الشفافية في الرواتب عن طريق",
        "main_no_salaries_link": "تقديم راتبك",
        "main_no_salaries_details_part_2": "أو بمشاركة هذا الموقع مع الآخرين.",

        // Calculator

        "calc_title": "حاسبة الرواتب",
        "calc_years_of_exp": "سنوات الخبرة",
        "calc_role": "المنصب",
        "calc_education_level": "المستوى التعليمي",
        "calc_location": "الموقع",
        "calc_calculate": "احسب",
        "calc_estimated": "نطاق الراتب المتوقع",
        "calc_error_msg": "الحاسبة لا تعمل حاليًا. ستكون متاحة بمجرد توفر بيانات كافية.",

        // FAQ
        "FAQs": "أسئلة شائعة",
        "faq_services_free_q": "هل خدماتكم مجانية للمستخدمين؟",
        "faq_services_free_a": "نعم, خدماتنا مجانية لجميع المستخدمين.",
        "faq_anonymous_q": "هل هويتي محفوظة؟",
        "faq_anonymous_a": "موقعنا يحترم خصوصيتك، ونضمن أن كل شيء يتم بشكل سري.",
        "faq_about_q": "ما هي خدمتكم؟",
        "faq_about_a": "خدمتنا هي قاعدة بيانات رواتب, حيث يمكن للمستخدمين البحث عن رواتب لوظائف وشركات محددة.",
        "faq_contribute_q": "كيف يمكنني المساهمة في قاعدة بيانات الرواتب؟",
        "faq_contribute_a": "اضغط هنا لإضافة راتبك",
        "faq_provide_q": "هل تقدمون بيانات الرواتب لجميع المجالات؟",
        "faq_provide_a": "نسعى لتغطية مجموعة واسعة من المجالات المهنية, ولكن قد تختلف تغطيتنا.",
        "faq_request_q": "هل يمكنني طلب بيانات راتب لوظيفة معينة؟",
        "faq_request_a": "اضغط هنا للإنتقال إلى صفحة استكشف",
        "faq_updated_q": "هل يتم تحديث بيانات الرواتب بانتظام؟",
        "faq_updated_a": "نعم، نسعى للحفاظ على تحديث بيانات الرواتب بانتظام لتقديم معلومات دقيقة.",
        "faq_account_q": "هل أحتاج حساب لإضافة راتبي؟",
        "faq_account_a": "لا, لكن الحساب سيساعدك في تتبع مساهماتك.",
        "faq_premium_q": "هل تقدمون أي خدمات مميزة؟",
        "faq_premium_a": "حاليًا، نقدم خدماتنا القياسية مجانًا لجميع المستخدمين.",

        // Footer
        "footer_contact": "اتصل بنا",
        "footer_tos": "شروط الخدمة",
        "footer_home": "الصفحة الرئيسية",
        "copyright": "© 2025 راتب. جميع الحقوق محفوظة.",

        // Login
        "login_signin": "تسجيل الدخول",
        "login_email": "البريد الإلكتروني",
        "login_password": "كلمة المرور",
        "login_forgot_password": "هل نسيت كلمة المرور؟",
        "login_login": "تسجيل الدخول",
        "login_not_a_member": "لست عضوًا؟ سجّل الآن",
        "login_alert_no_account": "لم يتم العثور على حساب يطابق البيانات المدخلة",

        //signup page
        "signup_header": "إنشاء حساب جديد",
        "signup_email": "البريد الإلكتروني",
        "signup_email_invalid": "بريد إلكتروني غير صالح",
        "signup_password" : "كلمة المرور",
        "signup_password_alert": "يجب أن تكون كلمة المرور مكونة من 8 أحرف على الأقل وتشمل الحروف والأرقام.",
        "signup_password_reentry" : "أعد إدخال كلمة المرور",
        "signup_password_reentry_alert": "إعادة الإدخال لا تطابق.",
        "signup_phone":"+9665xxxxxxxx",
        "signup_phone_alert": "رقم الهاتف غير صالح.",
        "signup_edu": "مستوى التعليم",
        "signup_edu_options": ["الثانوي", "دبلوم", "بكالوريوس", "ماجستير", "دكتوراه", "زمالة"],
        "signup_button": "انشئ الحساب",
        "signp_captcha_error":"قم بإدخال الكابتشا للمتابعة.",
        "signup_email_inuse": "البريد الإلكتروني أو رقم الهاتف مستخدم من قبل.",
        "signup_general_error": "حدث خطأ، يرجى المحاولة لاحقاً.",
        "signup_attempts_error": "لقد تجاوزت الحد الأقصى لعدد المحاولات. يرجى المحاولة لاحقاً.",

        //add salary page
        "addsalary_header":"أضف تاريخك الوظيفي",
        "addsalary_company": "اسم الشركة",
        "addsalary_role":"الوظيفة",
        "addsalary_exp":"سنوات الخبرة",
        "addsalary_edu":"مستوى التعليم",
        "addsalary_edu_options":["الثانوي", "دبلوم", "بكالوريوس", "ماجستير", "دكتوراه", "زمالة", "ماجستير إدارة أعمال"],
        "addsalary_num_error":"أدخل رقم",
        "addsalary_country":"الدولة",
        "addsalary_region":"المنطقة",
        "addsalary_city":"المدينة",
        "addsalary_salary":"الراتب الشهري",
        "addsalary_submit":"أضف راتبك",
        "addsalary_success": "تم إضافة راتبك بنجاح! سيتم إعادة التوجيه إلى الصفحة الرئيسية خلال 5 ثوان...",
        "addsalary_fail":"حدث خطأ، يرجى المحاولة لاحقاً.",
        "addsalary_captcha":"يرجى إكمال الكابتشا قبل الإرسال.",
        "addsalary_currency": "العملة",

        //explore page
        "discover_title": "استكشف الرواتب",
        "search_role": "ابحث بالمنصب...",
        "search_companies": "ابحث بالشركة...",
        "search_locations": "ابحث الموقع...",

        //discover companies page
        "discover_companies": "استكشف الشركات",
        "companies_subtitle": "ابحث عن شركات واكتشف رواتبهم ووظائفهم",
        "search_a_company": "ابحث عن شركات...",
        "popular_companies": "شركات شهيرة",
        "404_company": "لم يمكن العثور على هذه الشركة",

        //company page
        "company_median_title": "متوسط رواتب {companyDisplay}",
        "company_listed_title": "أحدث رواتب {companyDisplay} المسجلة ",
        "company_no_salaries" : "لا يوجد لدينا رواتب مدخلة لهذه الشركة",
        "company_median_sub": "رواتب {companyDisplay} تتراوح من {minSalary.median} SAR في الشهر ل{capitalizeEveryWord(minSalary.role)} بالحد الأدنى إلى {maxSalary.median} SAR ل{capitalizeEveryWord(maxSalary.role)} بالحد الأعلى.",
        "related_companies": "شركات مرتبطة",
        "discover_companies_related": "استكشف شركات ←",

        //about us page
        "mission_content": "مهمتنا أن نقوي الفرد بالمعرفة والرؤية اللازمة لاتخاذ قرارات عن مسارهم المهني.",
        "vision_title": "رؤيتنا",
        "vision_desc" : "توفير الرؤية والشفافية في سوق العمل،  مما يمكّن الموظف بإتخاذ قرارات مدروسة وكسب  نفوذ في مساراتهم العملية.",
        "mission_title": "مهمتنا",
        "mission_desc": "خرق الحدود وتنمية التطوير واحتظان أفكار جديدة لتشكيل مستقبل سوق العمل.",
        "innovation_title": "ابتكار",
        "innovation_desc": "تحدي الحدود باستمرار، وتشجيع الإبداع، واحتضان أفكار مختلفة لتشكيل المستقبل.",
        "customer_title": "تموحر حول العميل",
        "customer_desc": "العملاء هم قلب ما نفعله في راتب، أولويتنا هي احتياجاتهم ورضاهم.",
        "passion_title": "شغف",
        "passion_desc": "عملنا هو شغفنا، ونسعى للامتيازية في كل شيء نفعله.",
        "quality_title": "جودة",
        "quality_desc": "  نلتزم بتوصيل منتجاتنا وخدماتنا بأعلى جودة  ممكنة لعملائنا.",

        //employers page
        "offering_work": "اعمل معنا!",
        "offering_work_desc": "استفد من بياناتنا المتفصلة عن الرواتب في سوق العمل لدراسة ممارسات  دفع الرواتب لمنافسيك.  املأ الفجوات بمستوى تفصيل فريد، لا توفره استطلاعات الرواتب التقليدية.",
        "touch_button": "تواصل معنا",
        "offering_hire": "وظّف كفاءات عالية",
        "offering_hire_desc": "روّج لعلامة شركتك التجارية وسلّط الضوء على قيمتك كجهة توظيف. أنشر الوظائف على منصتنا واستهدف أفضل المواهب بذكاء.",
        "offering_150000": "+150,000",
        "offering_150000_desc": "أنشئ باقة بدلات جذابة لاستقطاب والاحتفاظ بأفضل المواهب. استخدم منهجيتنا للبيانات لتصميم باقات تلبي احتياجات موظفيك.",
        "offering_7000": "+7000",
        "offering_7000_desc": "نمّي علامتك التجارية كجهة توظيف من خلال منصتنا. اعرض ثقافة وقيمة شركتك، وفرصها المتاحة لاستقطاب المواهب المناسبة.",
        "offering_contact": "اتصل بنا",
        "offering_contact_desc": "ايميل: contact@ratib.io \n  اتصال: 2312 402 545 966+",

        //404 page
        "404page_msg":"لا يوجد شيء لتراه هنا، يا صاحبي!"

    }
    }
  }